import { EmployeeRole } from "@1games-ru/region-shared/dist/enums/business/employee";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import BusinessMpProvider from "@/core/data-provider/data-mp/business/business-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setEmployeesList } from "@/domains/business/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetEmployees() {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation("business");

  const [isPending, setIsPending] = useState(false);

  const getEmployees = useCallback(
    async (businessId: number, roles: EmployeeRole[]) => {
      setIsPending(true);
      try {
        const response = await BusinessMpProvider.getEmployees(businessId, roles);

        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setEmployeesList(response.data));
        } else if (i18n.exists(`business:business.errors.${response.error.message}`)) {
          console.error(response.error.message);
          toast.error(t(`business.errors.${response.error.message}`));
        } else {
          console.error(response.error.message);
          toast.error(t("business.toast.employeeLoadError"));
        }
      } catch (e) {
        console.error(e);
        toast.error(t("business.toast.employeeLoadError"));
      } finally {
        setIsPending(false);
      }
    },
    [dispatch, i18n, t],
  );

  return { isPending, getEmployees };
}
